import Block from './Block';
import Splide from '@splidejs/splide';

export default class SliderClouds extends Block {
  getElems() {
    this.sliderContainer = this.el.querySelector('.splide');
    this.slider = null;
    this.slides = Array.from(this.el.querySelectorAll('.splide__slide'));
  }

  init() {
    this.slider = new Splide(this.sliderContainer, {
      type: 'loop',
      perPage: 1,
      pagination: true,
      autoplay: true,
      breakpoints: {
        768: { perPage: 1 }
      }
    }).mount();
  }
}
